import { NavLink } from 'react-router-dom';

interface NavItem {
  path: string;
  label: string;
  icon: string; // Material Symbols icon name
  badge?: string;
  sprint: 1 | 2 | 3;
}

const navItems: NavItem[] = [
  { path: '/overview', label: 'Overview', icon: 'dashboard', sprint: 1 },
  { path: '/demo', label: 'Demo Mode', icon: 'play_circle', sprint: 1 },
  { path: '/pipeline', label: 'Pipeline Monitor', icon: 'timeline', sprint: 2 },
  { path: '/analytics', label: 'Triage Analytics', icon: 'bar_chart', sprint: 2 },
  { path: '/personas', label: 'Persona Manager', icon: 'person', sprint: 3 },
  { path: '/pricing', label: 'Pricing', icon: 'payments', sprint: 3 },
  { path: '/jurisdictions', label: 'Jurisdictions', icon: 'gavel', sprint: 3 },
  { path: '/prompts', label: 'Prompts', icon: 'edit_note', sprint: 3 },
  { path: '/review-queue', label: 'Review Queue', icon: 'rate_review', sprint: 3 },
  { path: '/voice', label: 'Voice Analytics', icon: 'mic', sprint: 3 },
];

export function Sidebar() {
  return (
    <aside className="w-64 bg-dark-800 border-r border-dark-700/50 flex flex-col min-h-screen">
      {/* Brand */}
      <div className="p-5 border-b border-dark-700/50">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-lg bg-rights-500/20 flex items-center justify-center">
            <span className="material-symbols-outlined text-rights-500 text-sm" style={{ fontVariationSettings: "'FILL' 1" }}>shield</span>
          </div>
          <div>
            <div className="text-sm font-display font-bold text-white">Rights Admin</div>
            <div className="text-[10px] text-dark-500 uppercase tracking-widest">tattlehash</div>
          </div>
        </div>
      </div>

      {/* Navigation */}
      <nav className="flex-1 p-3 space-y-0.5">
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors ${
                isActive
                  ? 'bg-rights-500/15 text-rights-500'
                  : 'text-dark-400 hover:bg-dark-700 hover:text-white'
              }`
            }
          >
            <span className="material-symbols-outlined text-lg">{item.icon}</span>
            <span className="flex-1">{item.label}</span>
            {item.badge && (
              <span className="px-1.5 py-0.5 text-[10px] bg-rights-500/20 text-rights-500 rounded-full font-semibold">
                {item.badge}
              </span>
            )}
          </NavLink>
        ))}
      </nav>

      {/* Footer */}
      <div className="p-4 border-t border-dark-700/50">
        <div className="text-[10px] text-dark-500 space-y-1">
          <p>rights.tattlehash.cloud</p>
          <p>v1.0.0</p>
        </div>
      </div>
    </aside>
  );
}
